import { FC, useEffect, useState } from 'react';
import { urlParams } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { useGetShareContent } from '@/common/hook/useShareContent';
import BasicLayout from '@/layout/BasicLayout';
import SpotSurveyDetail from './index';

/**
 * 踩点记录详情页
 */
const SpotsurveydetailPage: FC<{}> = () => {

  const [id, setId] = useState(null);

  useEffect(() => {
    const id = urlParams(location.search)?.id;
    if (id) {
      setId(id);
    }
  }, []);

  const { shareId, shareParams } = useGetShareContent({ onSuccess: (params) => methods.init(params) });

  /** 分享时调用接口需要的数据，如果有值代表“分享时” */
  const shareData = shareId && shareParams ? { tenantId: shareParams?.tenantId, userId: shareParams?.employeeId,
    ...(shareParams?.isSjtb ? { isSjtb: true } : {})
  } : null;

  const methods = useMethods({

    init(params) {
      setId(params?.id);
    },

  });

  return (
    id ? <BasicLayout>
      <SpotSurveyDetail id={id} shareData={shareData} />
    </BasicLayout> : <></>
  );
};

export default SpotsurveydetailPage;
